import { connect, store } from '../../../../../neb-redux/neb-redux-store';
import { NebTreatmentPlanState } from '../../../../../neb-treatment-plan/components/neb-treatment-plan-state';

export const NebPatientTreatmentPlanState = superClass =>
  class extends NebTreatmentPlanState(connect(store)(superClass)) {
    _shouldNotifyParent() {
      return false;
    }
  };
